/* global axios */
import ApiClient from './ApiClient';

// Generic requirements (requisitos) checklist API for any owner that includes the Requirementable
// concern (e.g. 'tramites'). The owner id is the resource's URL id. Enforcement is advisory — the
// only review action is `waive` (agent override) plus `reevaluate` (re-run auto-evaluation).
class RequirementsAPI extends ApiClient {
  constructor(ownerResource) {
    super('requirements', { accountScoped: true });
    this.ownerResource = ownerResource;
    this.ownerId = null;
  }

  get url() {
    return `${this.baseUrl()}/${this.ownerResource}/${this.ownerId}/requirements`;
  }

  get(ownerId) {
    this.ownerId = ownerId;
    return super.get();
  }

  create(ownerId, data) {
    this.ownerId = ownerId;
    return super.create({ requirement: data });
  }

  update(ownerId, id, data) {
    this.ownerId = ownerId;
    return super.update(id, { requirement: data });
  }

  delete(ownerId, id) {
    this.ownerId = ownerId;
    return super.delete(id);
  }

  reorder(ownerId, ids) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/reorder`, { ids });
  }

  reevaluate(ownerId) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/reevaluate`);
  }

  waive(ownerId, id, reviewNote) {
    this.ownerId = ownerId;
    return axios.post(`${this.url}/${id}/waive`, { review_note: reviewNote });
  }
}

export default RequirementsAPI;
